import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  failureDashboardDataCard,
  successDashboardDataCard,
} from "./DashboardDataCard";
import {
  failureDashboardCalenderData,
  successDashboardCalenderData,
} from "./DashboardCalenderData";
import {
  failureDashboardweeklypref,
  successDashboardweeklypref,
} from "./Dashboardweeklypref";
import { failureAchievements, successAchievements } from "./Achievements";
import {
  failureRecommended_Action,
  successRecommended_Action,
} from "./Recommended_Actions";

// cards data
const DashboardDataCardApi = () => {
  return api.get("/api/dashboard/weekly-analysis");
};

export function* DashboardDataCardCall() {
  try {
    const response: AxiosResponse = yield call(DashboardDataCardApi);
    yield put(successDashboardDataCard(response.data));
  } catch (error) {
    yield put(failureDashboardDataCard(error));
  }
}
const DashboardCalenderDataAPI = () => {
  return api.get("/api/dashboard/calendar");
};

export function* DashboardCalenderDataCall() {
  try {
    const response: AxiosResponse = yield call(DashboardCalenderDataAPI);
    yield put(successDashboardCalenderData(response.data));
  } catch (error) {
    yield put(failureDashboardCalenderData(error));
  }
}
const DashboardweeklyprefAPI = () => {
  return api.get("/api/dashboard/weekly-analysis");
};

export function* DashboardweeklyprefCall() {
  try {
    const response: AxiosResponse = yield call(DashboardweeklyprefAPI);
    yield put(successDashboardweeklypref(response.data));
  } catch (error) {
    yield put(failureDashboardweeklypref(error));
  }
}

const AchievementsAPI = () => {
  return api.get("/api/dashboard/acheivements");
};

export function* AchievementsCall() {
  try {
    const response: AxiosResponse = yield call(AchievementsAPI);
    yield put(successAchievements(response.data));
  } catch (error) {
    yield put(failureAchievements(error));
  }
}

const Recommended_ActionAPI = () => {
  return api.get("/api/dashboardactions");
};

export function* Recommended_ActionCall() {
  try {
    const response: AxiosResponse = yield call(Recommended_ActionAPI);
    yield put(successRecommended_Action(response.data));
  } catch (error) {
    yield put(failureRecommended_Action(error));
  }
}
